import React, { useEffect, useState } from "react";

import useHttp from "../../../hooks/use-http";

import moment from "moment";
import convertToExcel from "../../../components/ExportToExcel";
import Pagination from "../../../components/Pagination";

const VendorLedger = () => {
  const [data, setData] = useState([]);
  const [paymentRecieptTo, setPaymentRecieptTo] = useState(0);
  const [bankCashAccount, setBankCashAccount] = useState(0);

  const [bankCashAccountData, setBankCashAccountData] = useState([]);
  const [paymentRecieptToData, setPaymentRecieptToData] = useState([]);

  const { sendRequest: getData } = useHttp();

 

  const [accountId, setAccountId] = useState();
  const [accountMappingId, setAccountMappingId] = useState();

  
  const [openingDrAmount, setOpeningDrAmount] = useState(0);
  const [openingCrAmount, setOpeningCrAmount] = useState(0);

  const [closingBalance, setClosingBalance] = useState(0);
  const [closingBalanceType, setClosingBalanceType] = useState(0);
  const [finalClosingBalance, setFinalClosingBalance] = useState(0);
  const [finalClosingBalanceType, setFinalClosingBalanceType] = useState(0);

  const [accountData, setAccountData] = useState();
  const [accountMappedData, setaccountMappedData] = useState();


  const loadData = (type) => {
    const accType = type;

    
    getData(
      {
        url: `/api/accountLedgerList/?types=${accType}&orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
         
          setAccountData(data);
        
      }
    );
  };

  useEffect(() => {
    loadData("Vendor");
    
  }, []);

  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleFDateChange = (e) => {
    //console.log("handleFDateChange", e.target.value);
    setSelectedFromDate(e.target.value);
  };
  const handleTDateChange = (e) => {
    setSelectedToDate(e.target.value);
  };

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() - 15);

  const fromDate = d.toISOString().slice(0, 10);
  const [selectedFromDate, setSelectedFromDate] = useState(fromDate);

  const toDate = new Date().toISOString().slice(0, 10);

  //console.log("toDate", toDate);

  const [selectedToDate, setSelectedToDate] = useState(toDate);

  const { sendRequest: getReportData } = useHttp();

  const {
    isLoading: countload,
    error: counterror,
    sendRequest: getGeneralLedgerData,
  } = useHttp();

  
  const FillReports = ( accountId,accountMappingId) => {
     
    // var d = new Date(selectedToDate);     
    
    // d.setDate(d.getDate() +1);

    //   console.log("d",d)
    //   var tdate =moment(d).format("DD/MM/YYYY");

    var fdate=moment(selectedFromDate).format("DD/MM/YYYY");
    var tdate=moment(selectedToDate).format("DD/MM/YYYY");
    var urlfilter = "";

    urlfilter = urlfilter +`&fromDate=${fdate}`;
      urlfilter = urlfilter+`&toDate=${tdate}`;
   
      // farmerId=1684061154325785
    if (accountMappingId > 0) {
      urlfilter = urlfilter+ `&accountMappingId=${accountMappingId}`;
    }
    if (accountId > 0) {
      urlfilter = urlfilter+ `&accountId=${accountId}`;
    }
    
 
 

    var url = `/api/generalLedgerView/?orgId=${localStorage.getItem(
      "orgId"
    )}${urlfilter} `;

    getGeneralLedgerData(
      {
        url: url,
      },
      (data) => {
        console.log("reportdata", data);         
    
       
        var openingdata=data.openingvalue&&data.openingvalue[0];

        var totalDrAmount=parseFloat((openingdata&&openingdata.totalDrAmount)??0)
        var totalCrAmount=parseFloat((openingdata&&openingdata.totalCrAmount)??0)
        var closingBalance1=0
        var closingBalanceTemp=0
        var closingBalanceType1=""
        var closingBalanceTypeTemp=""

       

        if( (totalDrAmount-totalCrAmount)==0)
        {
          setOpeningDrAmount(0)
          setOpeningCrAmount(0)
          closingBalance1=0;
        }else 
        {
        
        if( (totalDrAmount-totalCrAmount)>0)
        {

          console.log("totalDrAmount-totalCrAmount",totalDrAmount-totalCrAmount)
          setOpeningDrAmount(totalDrAmount-totalCrAmount)
          setOpeningCrAmount(0)
          closingBalance1=totalDrAmount-totalCrAmount
          closingBalanceType1="Debit"
        }
        else
        {
          console.log("totalCrAmount-totalDrAmount",totalCrAmount-totalDrAmount)
          setOpeningCrAmount(totalCrAmount-totalDrAmount)
          setOpeningDrAmount(0)
          closingBalance1=totalDrAmount-totalCrAmount
          closingBalanceType1="Credit"
        }

        }
        setClosingBalance(closingBalance1)
        setClosingBalanceType(closingBalanceType1)
        var LedgerDetail=data.LedgerDetail
        closingBalanceTemp=closingBalance1
        closingBalanceTypeTemp=closingBalanceType1
        
        LedgerDetail.forEach(item => {

          closingBalanceTemp=Math.abs(closingBalanceTemp);
          if(parseFloat(item.drAmount)>0)
            {
              if(closingBalanceTypeTemp=="Debit")
              {
                closingBalanceTemp=closingBalanceTemp+parseFloat(item.drAmount)
              }else
              {
                closingBalanceTemp=closingBalanceTemp-parseFloat(item.drAmount)
                if(parseFloat(closingBalanceTemp)<0)
                {
                  closingBalanceTypeTemp="Debit"
                }
              }
            }else
            {

              if(parseFloat(item.crAmount)>0)
              {
                if(closingBalanceTypeTemp=="Credit")
                {
                  closingBalanceTemp=closingBalanceTemp+parseFloat(item.crAmount)
                }else
                {
                  closingBalanceTemp=closingBalanceTemp-parseFloat(item.crAmount)
                  if(parseFloat(closingBalanceTemp)<0)
                  {
                    closingBalanceTypeTemp="Credit"
                  }
                }
              }
            }
                 
            
          item.closingBalance=Math.abs(closingBalanceTemp);
                    
          if(Math.abs(closingBalanceTemp)!=0)
          { 
          item.closingBalanceType=closingBalanceTypeTemp;
          }

      });

      if(Math.abs(closingBalanceTemp)!=0)
      {
        setFinalClosingBalanceType(closingBalanceTypeTemp)
      }else {
        setFinalClosingBalanceType("")
      }
      setFinalClosingBalance( Math.abs(closingBalanceTemp))
      
    
        setData(LedgerDetail);
      } 
    );
  };

  useEffect(() => {
    FillReports( 0,0);
  }, [getGeneralLedgerData]);
  



  const {
    isLoading: farmerload,
    error: farmererror,
    sendRequest: getmappedAccount,
  } = useHttp();

  
  const FillMappedAccount= (accountId) => {
     
    setAccountMappingId("");
    getmappedAccount(
      {
        url: `/api/AccountMappingbyAccountIdForLedgerList/?orgId=${localStorage.getItem(
          "orgId"
        )}&accountId=${accountId}`,
       },
      (data) => {
         
        setaccountMappedData(data); //data.output.filter((item) => item.useCase == "Procurement");
    
      }
    );
    }

  useEffect(() => {
    FillReports(0, 0);
  }, [getReportData]);

  const fieldsToExport = [
    "bankcashAccountName",
    "bankcashCode",

    "paymentReceiptName",

    "paymentReceiptAccountName",

    "paymentReceiptAccountCode",
    "totalPaidAmount",
    "payReceiptType",
    "paymentReferenceNo",
  ];

  const customHeaders = [
    "Bank/Cash Account Name",
    "Bank/Cash Account Code",
    "Payee Name",
    "Payee Account Name",
    "Payee Account Code",
    "Paid Amount ",
    "Mode Of Payment/Receipt",
    "Payement Ref No",
  ];

  const handleExportExcel = () => {
    const filename = "VoucherPaymentReport.xlsx";

    convertToExcel(data, fieldsToExport, filename, customHeaders);
  };

  return (
    <>
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              {" "}
              <h3>Vendor Ledger Report</h3>
            </div>
            <hr />
            <div className="row"></div>

            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor={"General_Account"}>
                    {" Account"}
                  </label>
                  <select
                    id="emp_id"
                    className="form-control"
                    value={accountId}
                    onChange={(e) => {
                      var account_Id = 0;
                      if (e.target.value != "--Select--")
                        account_Id = e.target.value;

                      setAccountId(account_Id);
                      FillMappedAccount(account_Id);
                      FillReports(account_Id,0)
                    }}
                    required
                  >
                 <option value="">select</option>
                    {accountData &&
                      accountData.map((x) => (
                        <option
                          key={x.accountId}
                          user-id={x.accountId}
                          value={x.accountId}
                        >
                          {x.accountName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor={"executive_officer"}>{"Vendor"}</label>
                  <select
                    id="emp_id"
                    className="form-control"
                    value={accountMappingId}
                    onChange={(e) => {
                      var id = 0;
                      if (e.target.value != "--Select--") 
                        id = e.target.value;
                      
                      setAccountMappingId(id);
                      FillReports(accountId,id);
                    }}
                  >
                    <option value="">select</option>
                    {accountMappedData &&
                      accountMappedData.map((x) => (
                        <option
                          key={x.accountMappingId}
                          customer-id={x.accountMappingId}
                          value={x.accountMappingId}
                        >
                          {x.mappedName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  {" "}
                  <label htmlFor={"from_date"}>{"From Date"}</label>
                  <input
                    type={"date"}
                    id={"date"}
                    required
                    className="form-control"
                    max={currentDate}
                    value={selectedFromDate}
                    onChange={handleFDateChange}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <label htmlFor={"to_date"}>{"To Date"}</label>

                  <input
                    type={"date"}
                    id={"date"}
                    required
                    className="form-control"
                    max={currentDate}
                    value={selectedToDate}
                    onChange={handleTDateChange}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                <label htmlFor={"to_date"}>{"  "}</label>
                  <button
                     className="form-control"
                    onClick={(e) => {
                      FillReports(accountId,accountMappingId);
                    }}
                  >
                    Submit
                  </button>
                </div>{" "}
              </div>
            </div>
            <br />
            <span className="">
              Please select the parameters to get the desired result
            </span>
          </div>

          <hr />
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-warning"
                onClick={handleExportExcel}
              >
                <i className="fas fa-file-excel"></i>
              </button>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>

                  <table className="table table-bordered table-responsive text-center table-sm">
              <thead>
                <tr className="tableheaderrowview">
 
                <th>   Account </th>	             
                <th> Doc Code	</th>                 
                <th> Account Name	</th> 
                <th> Type	</th> 
                <th> Debit	</th> 
                <th> Credit	</th> 
                <th> Closing Balance	</th> 
                <th> Closing Credit/Debit	</th> 
                <th> Narration	</th> 
             </tr>
           </thead>

           <tbody>
            <tr>
               <td colSpan={4}>
            Opening Balance
               </td>

               <td>
                {openingDrAmount??0}
                </td>
                <td>
                {openingCrAmount??0}
                </td>
                <td>  
                  {closingBalance}              
                </td>
                <td>                  
                        {closingBalanceType}              
                </td>
            </tr>


             {currentItems &&
               currentItems.map((itm, i) => {
                 return (
                   <tr key={i} className="tablerowview">
                  
                              
                    
                     <td> {itm.transactionDate} </td>
                     <td>{itm.particularsCode}</td>
                     <td>{itm.accountName}</td>
                     <td>{itm.particularsType}</td>
                    
                     <td>{itm.drAmount}</td>
                     <td>{itm.crAmount}</td>
                     <td>{itm.closingBalance}  </td>
                     <td>{itm.closingBalanceType}</td>
                     <td>{itm.narration}</td>
                      </tr>
                    );
                  })}

<tr>
               <td colSpan={4}>
            Closing Balance
               </td>

               <td>
                
                </td>
                <td>
               
                </td>
                <td>      {finalClosingBalance}           
                </td>
                <td>      {finalClosingBalanceType}           
                </td>
                <td>
                { 
                 (finalClosingBalance==0 ? "-" :   
                (finalClosingBalanceType=="Debit"? "Receivable from customer" : "Payable from customer" ))
                 }  
               </td>
            </tr>

              </tbody>
            </table>
 
                  </div>

                  
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default VendorLedger;
